type Props = { text?: string; full?: boolean };

export function Loader({ text, full }: Props) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-4 py-12 ${
        full ? "min-h-screen" : ""
      }`}
    >
      <div className="relative w-10 h-10">
        <div className="absolute inset-0 rounded-full border-3 border-ink-100" />
        <div
          className="absolute inset-0 rounded-full border-3 border-transparent border-t-brand-purple animate-spin"
          style={{ animationDuration: "0.7s" }}
        />
      </div>
      {text && <div className="text-[14px] text-ink-500 font-medium">{text}</div>}
    </div>
  );
}
